import React, { useEffect, useState } from 'react';

import { 
    Form, 
    FormItemProps, 
    Select, 
    SelectProps
} from 'antd';

import { listApartment } from 'services/ApartmentService';

import { makeFilterOption } from './helpers/Form.helper';

type ApartmentFieldProps = { rules?: FormItemProps['rules'] };

const filterOption = makeFilterOption();

export function ApartmentField({ rules }: ApartmentFieldProps) {
    const [apartments, setApartments] = useState<Apartment.With<'tower'>[]>([]);

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchApartments = async () => {
            setIsLoading(true);

            const response = await listApartment();

            setIsLoading(false);

            if ('status' in response)
                return;

            setApartments(response);
        };

        fetchApartments();
    }, []);

    const options: SelectProps['options'] = apartments.map(({ id, name, tower}) => ({
        value: id,
        label: [tower.name, name].join(' '),
    }));

    return (
        <Form.Item
            name="apartment"
            label="Unidade"
            rules={rules}
        >
            <Select
                options={options}
                loading={isLoading}
                filterOption={filterOption}
                showSearch
                allowClear
            />
        </Form.Item>
    );
}
